import { FilterOperator, OrderType, useSearchExamCoursesQuery } from '@exam-center/graphql';
import {
  Flex,
  type GridRowSelectionModel,
  MenuBookOutlinedIcon,
  NoRowsOverlay,
  SearchInput,
  Text,
} from '@shared/components';
import { useState } from 'react';

import { BaseAdminExamCourseEnablementDataGrid } from '../../components';

import { columns } from './columns';

interface AdminExamCourseEnablementListProps {
  onSelectRow?: (selectedExamCourse: string | undefined) => void;
}

export default function AdminExamCourseEnablementList(
  props: Readonly<AdminExamCourseEnablementListProps>,
) {
  const { onSelectRow } = props;

  const [selectedExamCourse, setSelectedExamCourse] = useState<string[]>([]);

  const [searchInput, setSearchInput] = useState('');
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const { data, loading: isLoading } = useSearchExamCoursesQuery({
    variables: {
      searchExamCoursesInput: {
        filter: {
          conditions: [
            {
              field: 'enabled',
              operator: FilterOperator.Equal,
              value: false,
            },
          ],
          searchText: {
            fields: ['name'],
            value: searchInput,
          },
        },
        order: {
          field: 'examId',
          type: OrderType.Asc,
        },
        paging: {
          currentPage: page,
          pageSize,
        },
      },
    },
  });

  const rows = data?.ecSearchExamCourses.examCourses ?? [];
  const total = data?.ecSearchExamCourses.total ?? 0;

  const handleRowSelectionChange = (rowSelectionModel: GridRowSelectionModel) => {
    const selectedExamCourse = rowSelectionModel as string[];
    if (selectedExamCourse.length > 0) {
      const latestExamCourse = selectedExamCourse[selectedExamCourse.length - 1];
      setSelectedExamCourse([latestExamCourse]);
      onSelectRow?.(latestExamCourse);
    } else {
      setSelectedExamCourse([]);
      onSelectRow?.(undefined);
    }
  };

  const handleSearchInputChange = (value: string) => {
    setSearchInput(value);
    setPage(0);
  };

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(6) }}>
      <SearchInput placeholder='ค้นหาหลักสูตร...' onChange={handleSearchInputChange} />
      <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
        <Text variant='h4'>เลือกหลักสูตรทดสอบ (สามารถเลือกได้เพียง 1 หลักสูตรต่อครั้ง)</Text>
        <BaseAdminExamCourseEnablementDataGrid
          columns={columns}
          rows={rows}
          loading={isLoading}
          hideFooter={isLoading || total === 0}
          rowSelectionModel={selectedExamCourse}
          onRowSelectionModelChange={handleRowSelectionChange}
          slots={{
            noRowsOverlay: () => (
              <NoRowsOverlay title='ไม่มีข้อมูลหลักสูตร' icon={MenuBookOutlinedIcon} />
            ),
          }}
          slotProps={{
            footer: {
              total: total,
              pagination: {
                page: page,
                count: total,
                rowsPerPage: pageSize,
                onPageChange: (_event, page) => {
                  setPage(page);
                },
                onRowsPerPageChange: (event) => {
                  const pageSize = parseInt(event.target.value);
                  setPage(0);
                  return setPageSize(pageSize);
                },
              },
            },
          }}
        />
      </Flex>
    </Flex>
  );
}
